/**
 * ware-header
 * Handles mobile nav open/close and cart icon dispatching.
 */
class WareHeader extends HTMLElement {
  connectedCallback() {
    this._hamburger = this.querySelector('[data-hamburger]');
    this._mobileNav = document.querySelector('.ware-mobile-nav');
    this._closeBtn = document.querySelector('[data-mobile-nav-close]');
    this._cartBtn = this.querySelector('[data-cart-trigger]');
    this._overlay = document.querySelector('[data-mobile-nav-overlay]');

    if (this._hamburger) {
      this._hamburger.addEventListener('click', () => this._openNav());
    }
    if (this._closeBtn) {
      this._closeBtn.addEventListener('click', () => this._closeNav());
    }
    if (this._overlay) {
      this._overlay.addEventListener('click', () => this._closeNav());
    }
    if (this._cartBtn) {
      this._cartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this._mobileNav && this._mobileNav.classList.contains('is-open')) {
        this._closeNav();
      }
    });
  }

  _openNav() {
    if (!this._mobileNav) return;
    this._mobileNav.classList.add('is-open');
    this._mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const firstLink = this._mobileNav.querySelector('a');
    if (firstLink) firstLink.focus();
  }

  _closeNav() {
    if (!this._mobileNav) return;
    this._mobileNav.classList.remove('is-open');
    this._mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (this._hamburger) this._hamburger.focus();
  }
}

customElements.define('ware-header', WareHeader);
